module.exports = __webpack_public_path__ + "static/media/code-orange.5cecc7bb.svg";